<template>
  <section class="content">
    <div class="modal fade" id="help-basic" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>{{'help' | translate}}</h4>
          </div>
          <div class="modal-body">
            <h4>{{'base_params' | translate}}</h4>
            <p class="lead">{{'configure_base_params_text' | translate}}</p>
            <p>{{'soon_to_be_added' | translate}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'close' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-tags mr-5"></i>{{'edit-pricing-rules' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <p class="lead">{{'optimizer_box_header' | translate}}</p>
            <p class="text-warning"><i class="fa fa-exclamation-triangle mr-5"></i><strong>{{'optimizer_box_warning' | translate}}</strong></p>
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else>
        <div class="row">
          <div class="col-md-6 col-sm-8 col-xs-12">
            <h4>{{'pricing_rule_activation' | translate}}</h4>
            <p>{{'pricing_rule_activation_header' | translate}}<br>
              <small>Mit Aktivierung bestätigen Sie die aktuellen <a class="text-primary" href="/downloads/files" target="_blank" rel="opener">AGB's</a> gelesen und akzeptiert zu haben.</small>
            </p>
          </div>
            <div class="col-md-6 col-sm-4 col-xs-12">
                <div class="btn-group" data-toggle="btn-toggle">
                    <button @click="() => {config.is_active = true; postConfig()}" type="button" :class="['btn btn-success btn-app', config.is_active ? 'active' : '']"><i class="fa fa-check"></i>{{'is_active' | translate}}</button>
                    <button @click="() => {config.is_active = false;  postConfig()}" type="button" :class="['btn btn-danger btn-app', config.is_active ? '' : 'active']"><i class="fa fa-ban"></i>{{'inactive' | translate}}</button>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6 col-sm-8 col-xs-12">
            <h4>Preis für den Vergleich</h4>
            <p>Bitte wählen Sie hier, ob die Kalkulationen auf den UVP oder Ihren VKP (Streichpreis) durchgeführt werden sollen.</p>
          </div>
          <div class="col-md-6 col-sm-4 col-xs-12">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" :value="true" :checked="config.use_uvp" v-model="config.use_uvp"><strong>UVP</strong>
                </label>
              </div>
              <div class="radio mt-10">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" :value="false" :checked="!config.use_uvp" v-model="config.use_uvp"><strong>VKP</strong>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="margin"></div>
        <hr>
        <!-- ROI -->
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <h4>Min-Preis-Global</h4>
            <p>Bitte hinterlegen Sie hier den Prozentwert, den wir maximal von Ihrem UVP bzw. VKP abziehen dürfen.</p>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group">
              <span class="input-group-addon"><i class="fa fa-percent"></i></span>
              <input type="text" class="form-control" placeholder="z.B. 10" v-model="config.min_price_global">
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <h4>Min-Preis-Marke</h4>
            <p>Hier können Sie Marken mit individuellen Prozentsätzen versehen.<br><small class="text-muted">Diese Prozentsätze übersteuern den globalen Wert (Min-Preis-Global)</small></p>
            <div class="margin"></div>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <template v-for="row in config.min_price_brand" v-if="isInArray(row.brand, brands)">
              <div class="row pb-10">
                <div class="col-lg-8 col-md-7">
                  <div class="input-group">
                    <span class="input-group-addon"><strong>{{'brand' | translate}}</strong></span>
                    <vue-multiselect :options="brands" v-model="row.brand"></vue-multiselect>
                  </div>
                </div>
                <div class="col-lg-4 col-md-5">
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fa fa-percent"></i></span>
                    <input type="text" class="form-control" placeholder="z.B. 10" v-model="row.min_price">
                    <span class="input-group-btn">
                      <button class="btn btn-danger" @click="deleteFromArray(row, config.min_price_brand)"><i class="fa fa-trash"></i></button>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <div class="clearfix">
              <button class="btn btn-default btn-block btn-sm" @click="() => {config.min_price_brand.push({brand: '', min_price: 0})}">Neue Regel hinzufügen<i class="fa fa-plus ml-5"></i></button>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <h4>Min-Preis-Saison</h4>
            <p>Hier können Sie Saisons mit individuellen Prozentsätzen versehen.<br><small class="text-muted">Diese Prozentsätze übersteuern den globalen Wert (Min-Preis-Global) und den Marken-Wert (Min-Preis-Marke)</small></p>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <template v-for="row in config.min_price_season" v-if="isInArray(row.season, seasons)">
              <div class="row pb-10">
                <div class="col-lg-8 col-md-7">
                  <div class="input-group">
                    <span class="input-group-addon"><strong>{{'season' | translate}}</strong></span>
                      <select class="form-control" v-model="row.season">
                        <template v-for="s in seasons">
                          <option class="normal" :value="s">{{s}}</option>
                        </template>
                      </select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-5">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-percent"></i></span>
                  <input type="text" class="form-control" placeholder="z.B. 10" v-model="row.min_price">
                  <span class="input-group-btn">
                    <button class="btn btn-danger" @click="deleteFromArray(row, config.min_price_season)"><i class="fa fa-trash"></i></button>
                  </span>
                </div>
              </div>
              </div>
            </template>
            <div class="clearfix">
              <button class="btn btn-default btn-block btn-sm" @click="() => {config.min_price_season.push({season: '', min_price: 0})}">Neue Regel hinzufügen<i class="fa fa-plus ml-5"></i></button>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <h4>Min-Preis-Marke-Saison</h4>
            <p>Hier können Sie Marken einer speziellen Saison mit individuellen Prozentsätzen versehen.<br><small class="text-muted">Diese Prozentsätze übersteuern den globalen Wert (Min-Preis-Global), den Marken- (Min-Preis-Marke) und Saisonwert (Min-Preis-Saison)</small></p>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <template v-for="row in config.min_price_brand_season" v-if="isInArray(row.brand, brands) && isInArray(row.season, seasons)">
              <div class="row pb-10">
                <div class="col-lg-4 col-md-12">
                  <div class="input-group">
                    <span class="input-group-addon"><strong>{{'brand' | translate}}</strong></span>
                      <multiselect :options="brands" v-model="row.brand"></multiselect>
                  </div>
                </div>
                <div class="col-lg-4 col-md-12">
                  <div class="input-group">
                    <span class="input-group-addon"><strong>{{'season' | translate}}</strong></span>
                      <select class="form-control" v-model="row.season">
                        <template v-for="s in seasons">
                          <option class="normal" :value="s">{{s}}</option>
                        </template>
                      </select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-12">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-percent"></i></span>
                  <input type="text" class="form-control" placeholder="z.B. 10" v-model="row.min_price">
                  <span class="input-group-btn">
                    <button class="btn btn-danger" @click="deleteFromArray(row, config.min_price_brand_season)"><i class="fa fa-trash"></i></button>
                  </span>
                </div>
              </div>
              </div>
            </template>
            <div class="clearfix">
              <button class="btn btn-default btn-block btn-sm" @click="()=> {config.min_price_brand_season.push({season: '', brand: '', min_price: 0})}">Neue Regel hinzufügen<i class="fa fa-plus ml-5"></i></button>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <h4>Produkte ausschließen</h4>
            <p>Hier können Sie Ihre WWS-Nummern hinterlegen, die keine Preiskalkulationen erhalten sollen.</p>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <div class="margin visible-sm visible-xs"></div>
            <div class="form-group">
              <textarea class="form-control" rows="3" placeholder="z.B. 081-547-11-001; 081-562-11-002;" v-model="joinedProducts"></textarea>
            </div>
          </div>
        </div>
        </template>
      </div>
      <div class="box-footer">
        <div class="row">
          <div class="col-xs-12 text-right text-center-xs">
            <button class="btn btn-success btn-app no-margin" @click="postConfig(config)"><i class="fa fa-save"></i>{{'save' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect'
export default {
  components: {VueMultiselect},
  name: 'UVP',
  data () {
    return {
      loading: true,
      active: false,
      joinedProducts: '',
      alerts: [],
      brands: [],
      config: {},
      seasons: []
    }
  },
  computed: {
  },
  methods: {
    isInArray (needle, haystack) {
      if (needle === '') {
        return true
      }
      let exists = false
      haystack.forEach(h => {
        if (h === needle) {
          exists = true
        }
      })
      return exists
    },
    postConfig (data) {
      this.loading = true
      this.config.ignore_products = this.joinedProducts.split(';')
      API.post('uvp/bestPrice', this.config)
        .then(res => {
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
          this.loading = false
        })
    },
    formatData (data) {
      Object.keys(data).forEach(e => {
        e.toString().replace('.', ',')
      })
    },
    deleteFromArray (needle, haystack) {
      haystack.splice(haystack.indexOf(needle), 1)
    },
    reverseFormat (data) {
      data.forEach(c => {
        Object.keys(c).forEach(e => {
          if (e !== 'name') {
            let val = c[e].toString()
            c[e] = parseFloat(val.replace(',', '.'))
          }
        })
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('uvp/bestPrice')
        .then(res => {
          this.config = res.data.configuration
          this.joinedProducts = res.data.configuration.ignore_products.join(';')
          this.brands = res.data.brands
          this.seasons = res.data.seasons
          this.formatData(this.config)
          this.loading = false
        })
    })
  },
  watch: {
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  select option.normal{margin:40px;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4);background:#202227}
  .is-clickable {
    cursor: pointer;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__spinner {
    background: #212228 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }
</style>
<style scoped>
  .alert.alert-message {
    position: fixed;
  }
  .alert-dismissible {
    z-index: 9999;
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
  }
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Settings/Optimizer.vue